import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
// @redux
import {connect} from 'react-redux';
// @design-system
import ChipFilter from '../../../../design-system/components/Chip/ChipFilter';
import LoaderContent from '../../../../design-system/components/Loader/LoaderContent';
import NothingFound from '../../../../components/NothingFound/NothingFound';
import Toast from '../../../../design-system/components/Toast/Toast';
import Table from '../../../../design-system/components/Table/Table';
import Select from '../../../../design-system/components/Form/Select/Select';
import dateFormat from "../../../../design-system/utils/dateFormat";
import Dropdown from '../../../../design-system/components/Dropdown/Dropdown';
import TitleBanner from '../../../../design-system/components/Banners/TitleBanner';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import {ISO_DATE_FORMAT} from "../../../../design-system/constants/date-formats";
// @material-core
import {
  Icon,
  Grid,
  Box,
  Button,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
// @ThirtyParty
import {clone, isEmpty, isNil} from 'ramda';
import queryString from 'query-string';
import clsx from 'clsx';
import writeXlsxFile from 'write-excel-file';
import moment from 'moment';
// @local
import {modificacionesColumns, excelModificationsColumns} from '../ColumnsTable';
import {commonModuleStyles} from '../../../../assets/styles/jss/pages/common/CommonModuleStyles';
// @context
import {useB2BPermissions} from '../../../../context/B2BPermissionsContext';
// SDK
import {MembershipManagmentB2BService} from '@sdk-point/talisis';

const MembershipManagmentB2BServiceSDK = new MembershipManagmentB2BService(process.env.REACT_APP_ENV_V2, process.env.REACT_APP_X_API_KEY_V2);

const OPERATION_TYPES = [
    { id: 'baja', label: 'Baja' },
    { id: 'extension', label: 'Extensión' },
    { id: 'cambio_membresia', label: 'Cambio de Membresía' },
    { id: 'reenvio_correo', label: 'Envío de Correo' },
];

const ModificationsReportPage = (props) => {

  const classes = commonModuleStyles();
  const history = useHistory();
  const location = useLocation();
  const { filterCompaniesByScope, assignedCompanyName, autoSelectCompany } = useB2BPermissions();

  const [toast, setToast] = React.useState({toastProps: {message: '', open: false}});
  const [columns] = React.useState(modificacionesColumns);
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({data: [], dataSource: []});
  const [inputSearch, setInputSearch] = React.useState('');
  const [selectedFilters, setSelectedFilters] = React.useState({});
  const [filters, setFilters] = React.useState([]);
  const [showFilter, setShowFilter] = React.useState(false);
  // Criterio activo del "Buscar por" dentro de Filtro Avanzado. Según el valor se
  // habilita un control distinto: emailAddress -> textbox, requestedBy -> listado,
  // dateFrom -> calendario. Empresa y Tipo de Operación NO entran aquí: son los
  // filtros de la fila superior.
  const [searchBy, setSearchBy] = React.useState('emailAddress');
  const [catalogues, setCatalogues] = React.useState({companyTag: [], createdBy: []});
  const [loadingCompany, setLoadingCompany] = React.useState(false);
  const [loadingCreateBy, setLoadingCreateBy] = React.useState(false);

  const [messageTable] = React.useState({
    default: {
      caption: 'Selecciona tu criterio de búsqueda dando click en el botón de Filtrado avanzado.',
      subtitle: 'Filtra por correo, tipo de operación, solicitado por, fecha ó empresa.'
    },
    data: {
      caption: 'No se encontraron operaciones con los criterios seleccionados.',
      subtitle: 'Intenta con otros filtros o criterios de búsqueda.'
    }
  });

  const valueFilterLabels = {
    operationType: 'Tipo de Operación',
    requestedBy: 'Solicitado Por',
    dateFrom: 'Fecha',
    companyTagId: 'Empresa',
  };

  const valueFilterQueryStringURL = {
    operationType: 'operationType',
    requestedBy: 'requestedBy',
    dateFrom: 'dateFrom',
    companyTagId: 'companyTagId',
    emailAddress: 'emailAddress',
  };

  // Opciones del selector "Buscar por" del Filtro Avanzado. El id coincide con el
  // name del filtro que controla cada criterio, para habilitar el control correcto.
  const SEARCH_BY_OPTIONS = [
    { id: 'emailAddress', label: 'Correo' },
    { id: 'requestedBy', label: 'Solicitado Por' },
    { id: 'dateFrom', label: 'Fecha de Operación' },
  ];

  React.useEffect(() => {
    const params = {...selectedFilters};
    history.push({search: new URLSearchParams(params).toString()});
  }, [selectedFilters]);

  React.useEffect(() => {
    // Start empty on mount: do NOT restore filters from the URL nor auto-query.
    // The report stays empty until the user explicitly selects a company (and
    // optionally other filters). Only the catalogs for the dropdowns are loaded.
    setLoading(false);

    setLoadingCreateBy(true);
    getCreateBy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load/re-load the company catalog whenever the user's scope changes. The
  // permissions load is async and may resolve after mount, so re-filtering is
  // required for a recently assigned company to appear.
  React.useEffect(() => {
    setLoadingCompany(true);
    getCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignedCompanyName.join('|')]);

  // Catalogs load asynchronously, so a filter restored from the URL may first
  // render with the raw id. Recompute the chip labels once the catalogs arrive
  // so "Solicitado Por" shows the creator_name instead of the creator_id.
  React.useEffect(() => {
    if (!isEmpty(selectedFilters)) {
      hanledFilterUrl(selectedFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogues.createdBy, catalogues.companyTag]);

  const getCompanies = async () => {
    try {
      // Reuse the same SDK pattern as MembershipTablePage for companies
      const {data} = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({type: 'company'});
      // Restrict to the user's configured companies before mapping.
      const scoped = filterCompaniesByScope(data || []);
      // El filtro de empresa del reporte usa el id numérico de la empresa (item.id,
      // ej. 98) y se envía como companyTagId (ver getAllRequests).
      const companyTag = scoped.map(item => ({
        id: item.id,
        label: item.display_name,
        value: item.id,
        tag: item.tag
      }));
      setCatalogues(prevState => ({...prevState, companyTag}));

      // Autoselección: cuando el usuario tiene UNA sola empresa (efectiva), el
      // contexto entrega `autoSelectCompany`. El reporte se precarga con esa empresa
      // y se consulta directamente (no se queda vacío). Con 2+ empresas,
      // `autoSelectCompany` es null y el reporte se queda vacío como estaba (el
      // reporte no admite buscar más de una empresa a la vez). El match contra el
      // catálogo es por nombre normalizado (el id del scope no necesariamente
      // coincide con el id del catálogo). El filtro de empresa de este reporte usa
      // `companyTagId` (id numérico del catálogo).
      if (autoSelectCompany) {
        const normalize = (n) => (n || '').toString().trim().toUpperCase();
        const match = companyTag.find(
          (c) => normalize(c.label) === normalize(autoSelectCompany.company_name)
        );
        if (match) {
          const nextFilters = {...selectedFilters, companyTagId: match.value};
          setSelectedFilters(nextFilters);
          setFilters(prev => [
            ...prev.filter(f => !('companyTagId' in f)),
            {companyTagId: match.value, label: `${valueFilterLabels.companyTagId}: ${match.label}`},
          ]);
          getAllRequests(nextFilters);
        }
      }
    } catch (err) {
      // Silent fail for catalog load
    }
    setLoadingCompany(false);
  };

  // "Solicitado Por" filter options, sourced from /devel/users/b2b/create_by.
  // Same SDK method and mapping used by the Altas report (MembershipTablePage).
  const getCreateBy = async () => {
    try {
      const {data} = await MembershipManagmentB2BServiceSDK.getCatalogCreateBy();
      // Drop entries without a creator_id: the Select requires a non-null id and
      // a null option is not selectable anyway.
      const createdBy = (data || [])
        .filter(item => !isNil(item.creator_id))
        .map(item => ({
          id: item.creator_id,
          label: item.creator_name,
          value: item.creator_id,
        }));
      setCatalogues(prevState => ({...prevState, createdBy}));
    } catch (err) {
      // Silent fail for catalog load
    }
    setLoadingCreateBy(false);
  };

  const getAllRequests = async (overrideFilters) => {
    try {
      setLoading(true);
      let payload = overrideFilters || (isEmpty(selectedFilters) ? queryString.parse(location.search) : selectedFilters);

      // A company is MANDATORY. The report is not scope-aware, so a query without
      // companyTagId could return records outside the user's scope. Do not query
      // until a company is chosen.
      if (isEmpty(payload) || isNil(payload.companyTagId) || payload.companyTagId === '') {
        setState({data: [], dataSource: []});
        setLoading(false);
        return;
      }

      // El filtro de empresa del reporte se envía SOLO como companyTagId (id
      // numérico de la empresa, ej. 98). companyId no se envía por ahora.
      const response = await MembershipManagmentB2BServiceSDK.getModificationsReport(payload);
      const data = response?.data || [];

      setState({data, dataSource: data});
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (isNil(err)) {
        setToast({toastProps: {severity: "error", open: true, message: "Ops! Ha ocurrido un error"}});
      } else {
        setToast({toastProps: {severity: "error", open: true, message: err?.response?.data?.message || err.message}});
      }
    }
  };

  const handleChangeFilter = (e) => {
    let {target: {value, name, type}} = e;

    if (type === 'dateFrom') {
      value = dateFormat(value || '', ISO_DATE_FORMAT, 0, ['DD/MM/YYYY', 'YYYY-MM-DD']);
    }

    // Resolve display label
    let displayLabel = value;
    if (name === 'operationType') {
      const found = OPERATION_TYPES.find(item => item.id === value);
      if (found) displayLabel = found.label;
    } else if (name === 'companyTagId') {
      const found = catalogues.companyTag.find(item => String(item.id) === String(value));
      if (found) displayLabel = found.label || value;
    } else if (name === 'requestedBy') {
      // Show the creator_name (label), not the creator_id (value).
      const found = catalogues.createdBy.find(item => String(item.value) === String(value));
      if (found) displayLabel = found.label || value;
    }

    let filter = {};
    filter[name] = value;
    filter['label'] = `${valueFilterLabels[name]}: ${displayLabel}`;

    // Use functional updates so chaining filters (e.g. "Solicitado Por" then
    // "Empresa") never overwrites a previously set key from a stale closure.
    // Replace any existing chip/entry of the same type before adding the new one.
    setFilters(prev => [...prev.filter(f => !(name in f)), filter]);
    setSelectedFilters(prev => ({...prev, [valueFilterQueryStringURL[name]]: value}));
  };

  const onChangeSearch = (e) => {
    e.preventDefault();
    const {target: {value}} = e;
    let newInput = value.replace(/" "|\n|\t+/g, "");
    newInput = newInput.replace(/\s/g, "");

    setInputSearch(newInput);
    let newSelectedFilters = clone(selectedFilters);
    if (isEmpty(newInput) && newSelectedFilters.emailAddress !== undefined) {
      delete newSelectedFilters.emailAddress;
    } else {
      newSelectedFilters.emailAddress = newInput;
    }
    setSelectedFilters(newSelectedFilters);

    // Mantener sincronizado el chip de "Correo" para que sea VISIBLE y BORRABLE
    // (igual que Empresa / Solicitado Por / Fecha). Sin esto, el correo se guardaba
    // en selectedFilters pero no generaba chip, por lo que no se podía quitar y el
    // emailAddress viejo seguía ensuciando la búsqueda. Con texto -> se agrega/
    // reemplaza el chip; sin texto -> se quita.
    setFilters(prev => {
      const withoutEmail = prev.filter(f => !('emailAddress' in f));
      if (isEmpty(newInput)) return withoutEmail;
      return [...withoutEmail, { emailAddress: newInput, label: `Correo: ${newInput}` }];
    });
  };

  // Cambia el criterio del "Buscar por". Los filtros se ACUMULAN: cambiar de
  // criterio solo cambia qué control se muestra, SIN borrar los filtros ya
  // aplicados. Cada filtro se elimina individualmente con la tachita (X) de su chip.
  const handleChangeSearchBy = (e) => {
    setSearchBy(e.target.value);
  };

  const handleSearchByEmail = () => {
    setLoading(true);
    setState({data: [], dataSource: []});
    getAllRequests();
  };

  const onKeyDownSearch = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchByEmail();
    }
  };

  const handleDeleteChip = (chipToDelete) => () => {
    const newFilters = filters.filter((chip) => JSON.stringify(chip) !== JSON.stringify(chipToDelete));
    setFilters(newFilters);
    const key = Object.keys(chipToDelete).find(k => k !== 'label');
    // Al quitar el chip de correo, también limpiar el texto del input.
    if (key === 'emailAddress') {
      setInputSearch('');
    }
    setSelectedFilters((prevState) => {
      const newState = {...prevState};
      delete newState[valueFilterQueryStringURL[key]];
      return newState;
    });
  };

  const handleFilter = () => {
    // "Empresa" is MANDATORY (anchors the user's scope — the report must never
    // query outside the companies the user is allowed to see). "Solicitado Por"
    // is OPTIONAL: with just a company the report returns every record of that
    // company; adding "Solicitado Por" narrows it further.
    if (isNil(selectedFilters.companyTagId) || selectedFilters.companyTagId === '') {
      setToast({toastProps: {severity: "warning", open: true, message: 'Seleccione una empresa para consultar el reporte.'}});
      return;
    }

    setLoading(true);
    setShowFilter(false);
    setState({data: [], dataSource: []});
    getAllRequests();
  };

  const hanledFilterUrl = (params) => {
    let filters = [];
    Object.keys(params).forEach((k) => {
      let filter = {};
      if (valueFilterLabels[k]) {
        filter[k] = params[k];
        let displayLabel = params[k];
        if (k === 'operationType') {
          const found = OPERATION_TYPES.find(item => item.id === params[k]);
          if (found) displayLabel = found.label;
        } else if (k === 'companyTagId') {
          const found = catalogues.companyTag.find(item => String(item.id) === String(params[k]));
          if (found) displayLabel = found.label || params[k];
        } else if (k === 'requestedBy') {
          // Show the creator_name (label), not the creator_id (value).
          const found = catalogues.createdBy.find(item => String(item.value) === String(params[k]));
          if (found) displayLabel = found.label || params[k];
        }
        filter['label'] = `${valueFilterLabels[k]}: ${displayLabel}`;
        filters.push(filter);
      }
    });
    setFilters(filters);
  };

  const handledDownLoadExcel = async () => {
    try {
      setLoading(true);
      let datasource = state.data;

      await writeXlsxFile(datasource, {
        schema: excelModificationsColumns,
        fileName: `Reporte de Modificaciones B2B ${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`
      });

      setLoading(false);
    } catch (err) {
      setToast({toastProps: {severity: "error", open: true, message: err.message}});
      setLoading(false);
    }
  };

  return (
    <>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TitleBanner
          title="Modificaciones B2B - Reporte"
          desc="Consulte el historial de operaciones de modificación (bajas, extensiones y cambios de membresía) realizadas sobre alumnos B2B."
        />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent>
          <Grid container spacing={2} alignItems="center">
            {/* Fila superior (mismo nivel): Empresa (primer filtro, obligatorio) +
                Tipo de Operación + botón Buscar para consultar directo sin abrir el
                Filtro Avanzado. */}
            <Grid item xs={12} md={7}>
              <Box display="flex" alignItems="flex-end" style={{ gap: 8 }}>
                <Box style={{ flex: 1, minWidth: 0 }}>
                  <Select
                    items={catalogues.companyTag}
                    margin="dense"
                    variant="outlined"
                    label="Empresa"
                    name="companyTagId"
                    onChange={(e) => handleChangeFilter(e)}
                    disabled={!isNil(selectedFilters.companyTagId) || !catalogues.companyTag.length}
                    loading={loadingCompany}
                    value={!isNil(selectedFilters.companyTagId) ? selectedFilters.companyTagId : ''}
                    size="medium"
                    fullWidth
                  />
                </Box>
                <Box style={{ flex: 1, minWidth: 0 }}>
                  <Select
                    items={OPERATION_TYPES}
                    margin="dense"
                    variant="outlined"
                    label="Tipo de Operación"
                    name="operationType"
                    onChange={(e) => handleChangeFilter(e)}
                    value={!isNil(selectedFilters.operationType) ? selectedFilters.operationType : ''}
                    size="medium"
                    fullWidth
                  />
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleFilter()}
                  size="medium"
                  disabled={loading || isNil(selectedFilters.companyTagId) || selectedFilters.companyTagId === ''}
                  style={{ height: 44, minWidth: 110, flexShrink: 0, marginBottom: 4 }}
                >
                  Buscar
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box display="flex" justifyContent="flex-end" alignItems="center" style={{ gap: 12 }}>
                <Button
                  color="secondary"
                  variant={showFilter ? "contained" : "outlined"}
                  className={clsx(classes.button, showFilter ? classes.filterButton : classes.filterButtonOutlined)}
                  disabled={loading}
                  onClick={() => {
                    setShowFilter(!showFilter);
                  }}
                  size="small"
                  style={{ height: 40 }}
                >
                  <Typography variant='body2' noWrap> Filtro Avanzado</Typography>
                  <Icon className={clsx(showFilter ? "text-white" : "", "ri-equalizer-line", 'font-size-20')}
                        fontSize='small' style={{marginLeft: "6px"}}/>
                </Button>
                <Dropdown
                  text='Descargar Excel'
                  endIcon={<ArrowDropDownIcon className='font-size-24'/>}
                  style={{height: 40}}
                  variant='contained'
                  color='primary'
                  className={classes.button}
                  disabled={loading || state.data.length === 0}
                  onClick={() => handledDownLoadExcel()}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <ChipFilter chipData={filters} handleDelete={(e) => handleDeleteChip(e)} />
            </Grid>
          </Grid>
          {showFilter && (
            <Box display="flex" alignItems="flex-end" style={{ marginTop: 16, gap: 16 }}>
              {/* "Buscar por": selecciona el criterio y, según él, se habilita el
                  control correspondiente (Correo -> textbox, Solicitado Por ->
                  listado, Fecha de Operación -> calendario). Empresa y Tipo de
                  Operación viven en la fila superior, no aquí. */}
              <Box style={{ flex: 1, minWidth: 0 }}>
                <Select
                  items={SEARCH_BY_OPTIONS}
                  margin="dense"
                  variant="outlined"
                  label="Buscar por"
                  name="searchBy"
                  onChange={handleChangeSearchBy}
                  value={searchBy}
                  size="medium"
                  fullWidth
                />
              </Box>

              {/* Control dinámico según el criterio elegido */}
              <Box style={{ flex: 1, minWidth: 0 }}>
                {searchBy === 'emailAddress' && (
                  <TextField
                    name="emailAddress"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    placeholder="Escribe el correo"
                    value={inputSearch}
                    onChange={onChangeSearch}
                    onKeyDown={onKeyDownSearch}
                  />
                )}
                {searchBy === 'requestedBy' && (
                  <Select
                    items={catalogues.createdBy}
                    margin="dense"
                    variant="outlined"
                    name="requestedBy"
                    onChange={(e) => handleChangeFilter(e)}
                    disabled={!catalogues.createdBy.length}
                    loading={loadingCreateBy}
                    value={!isNil(selectedFilters.requestedBy) ? selectedFilters.requestedBy : ''}
                    size="medium"
                    fullWidth
                  />
                )}
                {searchBy === 'dateFrom' && (
                  <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="es">
                    <DatePicker
                      name="dateFrom"
                      inputVariant="outlined"
                      margin="dense"
                      fullWidth
                      value={selectedFilters.dateFrom ? moment(selectedFilters.dateFrom, ISO_DATE_FORMAT).toDate() : null}
                      onChange={(date) => {
                        const formattedDate = dateFormat(date || '', ISO_DATE_FORMAT, 0, ['DD/MM/YYYY', 'YYYY-MM-DD']);
                        handleChangeFilter({ target: { name: 'dateFrom', value: formattedDate, type: 'dateFrom' } });
                      }}
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      variant="dialog"
                      autoOk={false}
                      openTo="year"
                      views={['year', 'month', 'date']}
                      okLabel="OK"
                      cancelLabel="Cancel"
                    />
                  </MuiPickersUtilsProvider>
                )}
              </Box>

              <Box style={{ flex: 1 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleFilter()}
                  size="medium"
                  disabled={loading}
                  fullWidth
                  style={{ height: 40 }}
                >
                  Aplicar
                </Button>
              </Box>
            </Box>
          )}

          <LoaderContent loading={loading} minHeight={500}>
            {isNil(selectedFilters.companyTagId) || selectedFilters.companyTagId === '' ? (
              !loading && (
                <NothingFound
                  width='200px'
                  caption='Seleccione una empresa para consultar el reporte.'
                  subcaption='El reporte se filtra por la empresa que tenga configurada.'
                />
              )
            ) : state.data.length > 0 ? (
              <Table
                maxHeight={'800px'}
                columns={columns}
                rows={state.data}
              />
            ) : (
              !loading && (
                <NothingFound
                  width='200px'
                  caption={messageTable.data.caption}
                  subcaption={messageTable.data.subtitle}
                />
              )
            )}
          </LoaderContent>
        </CardContent>
      </Card>
      </Grid>
      </Grid>
      <Toast
        {...toast.toastProps}
        duration={5000}
        onFinished={() => setToast(prev => ({...prev, toastProps: {...prev.toastProps, open: false}}))}
      />
    </>
  );
};

const mapStateToProps = (state) => ({...state.userReducer});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModificationsReportPage);
